import type { CSSProperties } from 'vue';
export function cssSize(value: string | number | undefined): string | undefined {
  if (value === undefined) return undefined;
  return typeof value === 'number' || /^\d+(\.\d+)?$/.test(value) ? `${value}px` : value;
}
const semanticColors = new Set(['primary', 'secondary', 'success', 'error', 'warning', 'info', 'accent', 'surface', 'background', 'outline', 'on-surface', 'default']);
export function colorStyle(color?: string): CSSProperties {
  if (!color) return {};
  const name = color === 'default' ? 'on-surface' : color;
  return { '--ava-control-color': semanticColors.has(name) ? `rgb(var(--ava-color-${name}))` : name };
}
export function navigateTabs(event: KeyboardEvent): void {
  const list = event.currentTarget;
  if (!(list instanceof HTMLElement)) return;
  const tabs = Array.from(list.querySelectorAll<HTMLButtonElement>('[role="tab"]'));
  const index = tabs.indexOf(document.activeElement as HTMLButtonElement);
  if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
  event.preventDefault();
  const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1
    : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
  tabs[next]?.focus();
  tabs[next]?.click();
}
